// Class: starling.filters.FilterHelper

var $global = typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : this

$global.Object.defineProperty(exports, "__esModule", {value: true});

var __map_reserved = {};

// Imports

var $hxClasses = require("./../../hxClasses_stub").default;
var $hxEnums = require("./../../hxEnums_stub").default;
var $import = require("./../../import_stub").default;
function starling_filters_IFilterHelper() {return require("./../../starling/filters/IFilterHelper");}
function starling_utils_Pool() {return require("./../../starling/utils/Pool");}
function openfl__$Vector_Vector_$Impl_$() {return require("./../../openfl/_Vector/Vector_Impl_");}
function starling_textures_Texture() {return require("./../../starling/textures/Texture");}
function starling_utils_MathUtil() {return require("./../../starling/utils/MathUtil");}
function starling_textures_SubTexture() {return require("./../../starling/textures/SubTexture");}
function Std() {return require("./../../Std");}
function starling_core_Starling() {return require("./../../starling/core/Starling");}
function openfl_geom_Rectangle() {return $import(require("openfl/geom/Rectangle"));}
function openfl_geom_Matrix3D() {return $import(require("openfl/geom/Matrix3D"));}

// Constructor

var FilterHelper = function(textureFormat) {
	if(textureFormat == null) {
		textureFormat = "bgra";
	}
	this.sRegion = new (openfl_geom_Rectangle().default)();
	this._usePotTextures = (starling_core_Starling().default).get_current().get_profile() == "baselineConstrained";
	this._preferredScale = (starling_core_Starling().default).get_current().get_contentScaleFactor();
	this._textureFormat = textureFormat;
	this._sizeStep = 64;
	this._pool = (openfl__$Vector_Vector_$Impl_$().default)._new();
	this._projectionMatrix = new (openfl_geom_Matrix3D().default)();
	this._targetBounds = new (openfl_geom_Rectangle().default)();
	this.setSize(this._sizeStep,this._sizeStep);
}

// Meta

FilterHelper.__name__ = "starling.filters.FilterHelper";
FilterHelper.__isInterface__ = false;
FilterHelper.__interfaces__ = [(starling_filters_IFilterHelper().default)];
FilterHelper.prototype = {
	dispose: function() {
		(starling_utils_Pool().default).putRectangle(this._clipRect);
		this._clipRect = null;
		this.purge();
	},
	start: function(numPasses,drawLastPassToBackBuffer) {
		this._numPasses = drawLastPassToBackBuffer ? numPasses : -1;
	},
	getTexture: function(resolution) {
		if(resolution == null) {
			resolution = 1.0;
		}
		var texture;
		var subTexture;
		if(this._numPasses >= 0) {
			if(this._numPasses-- == 0) {
				return null;
			}
		}
		if(this._pool.length != 0) {
			texture = (openfl__$Vector_Vector_$Impl_$().default).pop(this._pool);
		} else {
			texture = (starling_textures_Texture().default).empty(this._nativeWidth / this._scale,this._nativeHeight / this._scale,true,false,true,this._scale,this._textureFormat);
		}
		if(!(starling_utils_MathUtil().default).isEquivalent(texture.get_width(),this._width,0.1) || !(starling_utils_MathUtil().default).isEquivalent(texture.get_height(),this._height,0.1) || !(starling_utils_MathUtil().default).isEquivalent(texture.get_scale(),this._scale * resolution)) {
			this.sRegion.setTo(0,0,this._width * resolution,this._height * resolution);
			subTexture = ((texture) instanceof (starling_textures_SubTexture().default)) ? texture : null;
			if(subTexture != null) {
				subTexture.setTo(texture.get_root(),this.sRegion,true,null,false,resolution);
			} else {
				texture = new (starling_textures_SubTexture().default)(texture.get_root(),this.sRegion,true,null,false,resolution);
			}
		}
		texture.get_root().clear();
		return texture;
	},
	putTexture: function(texture) {
		if(texture != null) {
			if(texture.get_root().get_nativeWidth() == this._nativeWidth && texture.get_root().get_nativeHeight() == this._nativeHeight) {
				(openfl__$Vector_Vector_$Impl_$().default).insertAt(this._pool,this._pool.length,texture);
			} else {
				texture.dispose();
			}
		}
	},
	purge: function() {
		var len = this._pool.length;
		var _g = 0;
		var _g1 = len;
		while(_g < _g1) {
			var i = _g++;
			this._pool[i].dispose();
		}
		this._pool.length = 0;
	},
	setSize: function(width,height) {
		var factor;
		var newScale = this._preferredScale;
		var maxNativeSize = (starling_textures_Texture().default).getMaxSize(this._textureFormat);
		var newNativeWidth = this.getNativeSize(width,newScale);
		var newNativeHeight = this.getNativeSize(height,newScale);
		if(newNativeWidth > maxNativeSize || newNativeHeight > maxNativeSize) {
			factor = maxNativeSize / Math.max(newNativeWidth,newNativeHeight);
			newNativeWidth = (Std().default).int(newNativeWidth * factor);
			newNativeHeight = (Std().default).int(newNativeWidth * factor);
			newScale *= factor;
		}
		if(this._nativeWidth != newNativeWidth || this._nativeHeight != newNativeHeight || this._scale != newScale) {
			this.purge();
			this._scale = newScale;
			this._nativeWidth = newNativeWidth;
			this._nativeHeight = newNativeHeight;
		}
		this._width = width;
		this._height = height;
	},
	getNativeSize: function(size,textureScale) {
		var nativeSize = size * textureScale;
		if(this._usePotTextures) {
			if(nativeSize > this._sizeStep) {
				return (starling_utils_MathUtil().default).getNextPowerOfTwo(nativeSize);
			} else {
				return this._sizeStep;
			}
		} else {
			return Math.ceil(nativeSize / this._sizeStep) * this._sizeStep;
		}
	},
	get_projectionMatrix3D: function() {
		return this._projectionMatrix;
	},
	set_projectionMatrix3D: function(value) {
		this._projectionMatrix.copyFrom(value);
		return value;
	},
	get_renderTarget: function() {
		return this._renderTarget;
	},
	set_renderTarget: function(value) {
		return this._renderTarget = value;
	},
	get_clipRect: function() {
		return this._clipRect;
	},
	set_clipRect: function(value) {
		if(value != null) {
			if(this._clipRect != null) {
				this._clipRect.copyFrom(value);
			} else {
				this._clipRect = (starling_utils_Pool().default).getRectangle(value.x,value.y,value.width,value.height);
			}
		} else if(this._clipRect != null) {
			(starling_utils_Pool().default).putRectangle(this._clipRect);
			this._clipRect = null;
		}
		return value;
	},
	get_targetBounds: function() {
		return this._targetBounds;
	},
	set_targetBounds: function(value) {
		this._targetBounds.copyFrom(value);
		this.setSize(value.width,value.height);
		return value;
	},
	get_target: function() {
		return this._target;
	},
	set_target: function(value) {
		return this._target = value;
	},
	get_textureScale: function() {
		return this._preferredScale;
	},
	set_textureScale: function(value) {
		return this._preferredScale = value > 0 ? value : (starling_core_Starling().default).get_current().get_contentScaleFactor();
	},
	get_textureFormat: function() {
		return this._textureFormat;
	},
	set_textureFormat: function(value) {
		return this._textureFormat = value;
	}
};
FilterHelper.prototype.__class__ = FilterHelper.prototype.constructor = $hxClasses["starling.filters.FilterHelper"] = FilterHelper;

// Init

Object.defineProperties(FilterHelper.prototype,{ projectionMatrix3D : { get : function () { return this.get_projectionMatrix3D (); }, set : function (v) { return this.set_projectionMatrix3D (v); }}, renderTarget : { get : function () { return this.get_renderTarget (); }, set : function (v) { return this.set_renderTarget (v); }}, clipRect : { get : function () { return this.get_clipRect (); }, set : function (v) { return this.set_clipRect (v); }}, targetBounds : { get : function () { return this.get_targetBounds (); }, set : function (v) { return this.set_targetBounds (v); }}, target : { get : function () { return this.get_target (); }, set : function (v) { return this.set_target (v); }}, targetScale : { get : function () { return this.get_targetScale (); }, set : function (v) { return this.set_targetScale (v); }}, textureFormat : { get : function () { return this.get_textureFormat (); }, set : function (v) { return this.set_textureFormat (v); }}});

// Statics




// Export

exports.default = FilterHelper;